export const convertCentsToBRL = (value: number): number => {
  return value / 100;
};
